<template>
  <div
    v-if="barChartVisitacaoHorario.chartData.labels.length > 0"
    :style="`min-width:${
      barChartVisitacaoHorario.chartData.labels.length * 8
    }px;max-width:100%;`"
  >
    <bar-chart
      id="pie-chart-size"
      :height="height"
      :chart-data="barChartVisitacaoHorario.chartData"
      :extra-options="barChartVisitacaoHorario.extraOptions"
    ></bar-chart>
  </div>
</template>

<script>
import moment from 'moment'
import BarChart from '@/components/Charts/BarChart'
import defaultChartObjects from '../defaultChartObjects'
import { mapActions, mapGetters } from 'vuex'

export default {
  component: 'BarChartHorario',

  components: {
    BarChart,
  },

  props: {
    height: {
      type: Number,
      default: 250,
    },

    colors: {
      type: Array,
      default: [],
    },

    fetchProgress: {
      type: Number,
      default: 0 | 100,
    },

    tableData: {
      type: Array,
      default: [],
    },

    clientsCountItemName: {
      type: String,
      default: 'itens',
    },

    defaultBarThickness: {
      type: Number,
      default: 8,
    },

    billItemName: {
      type: String,
      default: 'item',
    },

    finishedBillName: {
      type: String,
      default: 'item',
    },

    selectedbillItensNames: {
      type: Array | Object,
      default: [] | {},
    },
  },

  data: () => {
    return {
      maxBarThickness: 30,
    }
  },

  methods: {
    ...mapActions('product', ['productStoreCommit']),

    //METHOD TO GROUP BY KEYGETTER.
    //KEYGETTER MUST BE "foo => foo.fieldYouWantToGroupBy"
    groupBy(list, keyGetter) {
      const map = new Map()
      list.forEach((item) => {
        const key = keyGetter(item)
        const collection = map.get(key)
        if (!collection) {
          map.set(key, [item])
        } else {
          collection.push(item)
        }
      })
      return Array.from(map)
    },
  },

  computed: {
    ...mapGetters('product', {
      useChartCache: 'getUseChartCache',
      chartObject: 'getBarChartHorario',
    }),

    monthNamesAbr() {
      return [
        'Jan',
        'Fev',
        'Mar',
        'Abr',
        'Mai',
        'Jun',
        'Jul',
        'Ago',
        'Set',
        'Out',
        'Nov',
        'Dez',
      ]
    },

    barChartVisitacaoHorario() {
      var defaultChart = {}
      defaultChart = JSON.parse(
        JSON.stringify(defaultChartObjects.defaultBarChartHorario)
      )

      if (
        this.useChartCache == true &&
        this.chartObject.chartData != undefined
      ) {
        defaultChart = JSON.parse(JSON.stringify(this.chartObject))
        if (this.fetchProgress < 100) {
          sessionStorage.removeItem('SET_BAR_CHART_HORARIO_save')
        }
      }

      if (
        this.fetchProgress == 0 ||
        (this.fetchProgress == 100 &&
          !sessionStorage.getItem('SET_BAR_CHART_HORARIO_save'))
      ) {
        let dados = []
        let vm = this

        this.tableData.map((tableDataItem) => {
          if (tableDataItem.trafx) {
            dados.push([
              tableDataItem.date_created,
              tableDataItem.checkin.dateTime,
              tableDataItem,
            ])
          } else {
            dados.push([
              tableDataItem.date_created * 1000,
              tableDataItem.checkin.dateTime,
              tableDataItem,
            ])
          }
        })

        var valores = dados.map(function (val, idx) {
          return val[2]
        })
        var date_created_data = new Array(24).fill(0)
        var checkin_data = new Array(24).fill(0)
        var trafx_data = new Array(24).fill(0)
        var finance_data = new Array(24).fill(0)
        var labels = new Array(24).fill(0)

        labels.map((v, i) => {
          labels[i] = `${i > 9 ? '' : '0'}${i}:00`
        })

        valores.map(function (booking, index) {
          var hour = new Date(booking.date_created * 1000).getHours()

          date_created_data[hour] =
            date_created_data[hour] + Number(booking.people.tableText.count)

          if (booking.trafx == true) {
            var entries = vm.groupBy(booking.entries, (el) => el)
            entries.map(function (v, i) {
              var entryHour = moment(v[0], 'YYYY-MM-DD HH:mm').hour()
              var amount = v[1].length
              trafx_data[entryHour] += amount
            })
          }

          if (booking.finance) {
            hour = new Date(booking.date_created * 1000).getHours()
            finance_data[hour] =
              checkin_data[hour] + Number(booking.people.tableText.count)
          }

          if (booking.checkin.hasCheckin) {
            hour = new Date(booking.checkin.dateTime * 1000).getHours()
            checkin_data[hour] =
              checkin_data[hour] + Number(booking.people.tableText.count)
          } else {
            // checkin_data[hour] = checkin_data[hour] + 0
          }
        })

        defaultChart.chartData = {
          labels: labels,
          datasets: [
            {
              label: `Horário de ${this.billItemName.slice(0, -1)}`,
              yAxisID: 'A',
              data: date_created_data,
              barThickness: this.defaultBarThickness,
              maxBarThickness: this.maxBarThickness,
              borderColor: this.colors[1],
              backgroundColor: 'transparent', //'#C02221',
              type: 'line',
            },
            {
              label: `Horário de ${this.finishedBillName}`,
              yAxisID: 'A',
              data: checkin_data,
              barThickness: this.defaultBarThickness,
              maxBarThickness: this.maxBarThickness,
              borderColor: this.colors[2],
              backgroundColor: 'transparent', //'#97af25',
              type: 'line',
            },
            {
              label: 'Horário Trafx',
              yAxisID: 'A',
              data: trafx_data,
              barThickness: this.defaultBarThickness,
              maxBarThickness: this.maxBarThickness,
              borderColor: this.colors[4],
              backgroundColor: 'transparent',
              type: 'line',
            },
            {
              label: 'Horário Financeiro',
              yAxisID: 'A',
              data: finance_data,
              barThickness: this.defaultBarThickness,
              maxBarThickness: this.maxBarThickness,
              borderColor: this.colors[3],
              backgroundColor: 'transparent',
              type: 'line',
            },
          ],
        }
        defaultChart.extraOptions = {
          legend: {
            display: true,
            position: 'bottom',
          },
          tooltips: {
            callbacks: {
              label: function (tooltipItem) {
                if (tooltipItem.datasetIndex == 0) {
                  return `${Number(tooltipItem.value)} reservaram`
                } else if (tooltipItem.datasetIndex == 1) {
                  return `${Number(tooltipItem.value)} fizeram check-in`
                } else if (tooltipItem.datasetIndex == 2) {
                  return `${Number(tooltipItem.value)} trafx contados`
                } else if (tooltipItem.datasetIndex == 3) {
                  return `${Number(tooltipItem.value)} entradas financeiras`
                }
              },
            },
          },
          scales: {
            yAxes: [
              {
                id: 'A',
                type: 'linear',
                position: 'left',
              },
            ],
          },
        }

        if (
          this.useChartCache == true &&
          this.fetchProgress == 100 &&
          !sessionStorage.getItem('SET_BAR_CHART_HORARIO_save')
        ) {
          sessionStorage.setItem('SET_BAR_CHART_HORARIO_save', '1')
          this.productStoreCommit({
            mutation: 'SET_BAR_CHART_HORARIO',
            value: JSON.parse(JSON.stringify(defaultChart)),
          })
        }
      }

      return defaultChart
    },
  },
}
</script>
